import CryptoJS from "crypto-js";
 import AWS from 'aws-sdk';
 
AWS.config.update({
  secretkey: process.env.REACT_APP_CRYPTO_SECRET_KEY,
});
let SECRET_KEY="92375678801274567898123856780012"
 
export const decryptData = (encryptedString) => {
  try {
    const [ivBase64, encryptedBase64] = encryptedString.split(":");
 
    const key = CryptoJS.enc.Utf8.parse(SECRET_KEY);
    // const key = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_CRYPTO_SECRET_KEY);
    const iv = CryptoJS.enc.Base64.parse(ivBase64);
    const encrypted = CryptoJS.enc.Base64.parse(encryptedBase64);
 
    const decrypted = CryptoJS.AES.decrypt(
      { ciphertext: encrypted },
      key,
      {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      }
    );
 
    const decryptedText = decrypted.toString(CryptoJS.enc.Utf8);
    return JSON.parse(decryptedText);
  } catch (err) {
    console.error("Decryption failed:", err);
    return null;
  }
};